const cache = {};

export const hasImage = imageUrl => typeof cache[imageUrl] !== 'undefined';

export const getImage = imageUrl => hasImage(imageUrl) ? cache[imageUrl] : null;

export const addImage = (imageUrl, image) => {
  cache[imageUrl] = image;
};
